export const FETCH_FAVORITES = 'FAVORITES/FETCH_FAVORITES';
export const FETCH_FAVORITES_SUCCESS = 'FAVORITES/FETCH_FAVORITES_SUCCESS';
export const FETCH_FAVORITES_ERROR = 'FAVORITES/FETCH_FAVORITES_ERROR';
export const DELETE_FAVORITE = 'FAVORITES/DELETE_FAVORITE';
export const DELETE_FAVORITE_SUCCESS = 'FAVORITES/DELETE_FAVORITE_SUCCESS';
export const DELETE_FAVORITE_ERROR = 'FAVORITES/DELETE_FAVORITE_ERROR';
export const RESET_STATE = 'FAVORITES/RESET_STATE';